import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Maintance = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className='flex justify-center items-center h-full'>
            <Result
                status="500"
                title={t('common.maintance')}
                subTitle={t('common.maintance_exp')}
                extra={<Button type="primary" key="console" onClick={() => goBack()}>{t('common.go_back')}</Button>}
            />
        </div>
    )
}

export default Maintance